import SendIcon from '@mui/icons-material/Send';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { FilledInfoBar } from '../../components/_DesignSystemWrappers/InfoBar/FilledInfoBar';
import { PATHS } from '../../config/consts';
import { logout, resendConfirmationEmailRequest, resetAuthStore } from '../../modules/auth/actions';
import { getResendEmail } from '../../modules/auth/selectors';
import { LoginFlowsWrapper } from '../_components/LoginFlowsWrapper/LoginFlowsWrapper';
import { useAppContext } from '../App/AppContextProvider';
import { RouterLink } from '../ResetPasswordPage/components/Link/PrimaryLink';
import messages from './messages';

export function Resend() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const storedResendEmail = useSelector(getResendEmail);
  const emailToResend = useRef('');
  const { loggedIn } = useAppContext();

  const resendEmail = () => {
    if (emailToResend.current) {
      dispatch(resendConfirmationEmailRequest({ email: emailToResend.current }));
    }
  };

  useEffect(() => {
    if ((storedResendEmail?.length ?? 0) === 0 && loggedIn) {
      dispatch(logout());
      return;
    }

    if (storedResendEmail) {
      emailToResend.current = storedResendEmail;
      dispatch(resetAuthStore());
    }
  }, [loggedIn, storedResendEmail]);

  return (
    <Box sx={{ backgroundColor: 'background.paper' }}>
      <LoginFlowsWrapper title={formatMessage(messages.resendTitle)}>
        <Stack spacing={2}>
          <Stack spacing={3}>
            <FilledInfoBar>
              <Typography variant="body2">
                <FormattedMessage {...messages.resendDescription} />
              </Typography>
            </FilledInfoBar>
            <Button
              color="primary"
              fullWidth
              id="login-button"
              onClick={resendEmail}
              size="large"
              startIcon={<SendIcon />}
              type="submit"
              variant="contained"
            >
              <FormattedMessage {...messages.resendBtnResend} />
            </Button>
          </Stack>
          <RouterLink to={PATHS.LOGIN}>
            <FormattedMessage {...messages.resendBackToLogin} />
          </RouterLink>
        </Stack>
      </LoginFlowsWrapper>
    </Box>
  );
}
